module.exports = __webpack_public_path__ + "assets/img/zpimg5.c4d286fe.png";